import React, { useState } from 'react'
import { graphql } from 'gatsby'
import { useLocation } from '@reach/router'
import { navigate } from "gatsby"

import { Layout } from "../components/layout"
import { MetaHead } from "../components/layout/meta-head"
import { Container } from "../components/Container"

import HomePageTemplate from "../templates/page/home"
import PageTemplate from "../templates/page/page-template"
import ContactPage from "../templates/page/contact/contact"
import NotFoundPage from "../templates/page/not-found-page/not-found-page"
import Confirmation from "../templates/page/confirmation"
import Blog from "../templates/page/blog/blog"
import Draft from "../templates/page/draft"
import PageCategories from "../templates/page/page-categories"
import SavorPinterest from "../templates/page/pinterest"

import { Certification, ProductParts, ContentCard, ContentTwoColumn, Accessories, PackagingPrintHouse, TourComponent } from "../components/PageContent"
import ContactForm from "../components/ContactForm"
import BlogInterest from "../components/BlogInterest/BlogInterest"
import { PackagingTips } from "../templates/page/blog-categories"
import { FarmersAndProducers } from "../components/PageContent/FarmersAndProducers"
import { PageContentSection } from '../components/PageContentSection'
import { ModalProvider } from '../context/modalProvider'
import Gallery from '../components/Gallery'
import { Appointments } from '../components/Appointments'

const Page = ({ data }) => {
    const location = useLocation()
    const locPathname = location.pathname


    let pageTemplate = data.contentfulPage.pageTitle === 'Page not found'
    ? <NotFoundPage data={data} />
    : data.contentfulPage.pageTitle === 'Home' || data.contentfulPage.pageTitle === 'Hogar'
    ? <HomePageTemplate data={data.contentfulPage} /> 
    : data.contentfulPage.id === '8f90fb98-e4af-56f6-8f67-e919b16a9a89'  || data.contentfulPage.id === 'a831fcf5-351b-5f61-841c-d7f39c9cab8e'
    ? <Blog data={data.contentfulPage} />
    : data.contentfulPage.pageTitle === 'Contact' || data.contentfulPage.id === 'abede8b2-e2ce-5cd7-abbd-1ca517494f8f'
    ? <ContactPage data={data} /> 
    : data.contentfulPage.id === '49d10d35-2cdd-5bae-aaa8-2b1624b3749c'
    ? <Draft content={data.contentfulPage} /> 
    : data.contentfulPage.id === '04937b47-9e92-5b99-abc6-ab9ab26fc185'
    ? <PageCategories pageData={data.contentfulPage} /> 
    : data.contentfulPage.pageTitle === 'Thank you Page' || data.contentfulPage.id === 'c1c2689b-8710-5bf7-8db2-4d98a9b26d17'
    ? <Confirmation data={data} />
    : data.contentfulPage.id === '18677227-b341-5c8b-bbd1-a42d3c4688e6'
    ? <SavorPinterest/>
    : data.contentfulPage.id === '10c7fb68-e490-59c0-a139-2bd220c24786'
    ? <PackagingTips/>
    :  <PageTemplate data={data} />;

    const pageData = data.contentfulPage
    const productpartData = data.allContentfulPackagingParts
    let coffeePackagingTour = data.allContentfulCoffeePackagingTour.edges

    const [languageSelected, setLanguage] = useState('en')
    const handleLanguageChange = (lang) => {
        if (lang === 'es') {
          navigate('/es/')
        } else {
          navigate('/')
        }
        setLanguage(lang)
    }

    return (
        // <Layout isHeaderDark={data.contentfulPage.isHeaderDark} isDefaultHeader={(pageData.pageLanguage !== null) ? false : true} languageToggle={languageToggle} languageSelected={languageSelected}>
        <Layout 
            isHeaderDark={data.contentfulPage.isHeaderDark} 
            languageToggle={handleLanguageChange}
            languageSelected={languageSelected}
            setLanguage={setLanguage}
        >
            {pageTemplate}

            <FarmersAndProducers sectionVisibility={locPathname === '/hermetica/' || locPathname === '/hermetica/spanish/' || locPathname === '/hermetica/portuguese/'} />
            <ContentCard pageData={pageData.pageContentCard} />
            <PageContentSection sectionVisibility={pageData?.pageContentSection?.sections} sections={pageData?.pageContentSection?.sections} />
            {pageData.id === '22115bb8-499c-5e7e-b88d-682a112012d9' && <Appointments/>}
            {pageData.pageGallery !== null && pageData.pageGallery.map((galleryData, index) => (
                <div className='bg-frost-white'>
                    <ModalProvider key={index}>
                        <Gallery key={index} galleryData={galleryData} isFluid={false} />
                    </ModalProvider>
                </div>
            ))}
            <TourComponent sectionVisibility={pageData.coffeePackagingTourImage} content={pageData} coffeePackagingTour={coffeePackagingTour}/>

            {pageData.listOfCertifiedLogos !== null && <Certification certifiedLogos={pageData.listOfCertifiedLogos}/>}
            {pageData.id === '14bac12a-1e55-5184-a99c-b96f7ded106d' && <ProductParts parts={productpartData.nodes} />}
            <PackagingPrintHouse pageData={pageData} />
            
            <ContentTwoColumn pageData={pageData.pageContentTwoColumn}/>
            <Accessories accessories={pageData.accessoriesSection}/>

            {pageData.hasContactForm && (<ContactForm pageName={pageData.headerPageTitle} colorValue={pageData.id === '22115bb8-499c-5e7e-b88d-682a112012d9' ? 'rgb(229, 62, 62)' : ''} pageData={pageData} />)}
            {(pageData.id !== '2f7c3da8-7e43-5e1e-8ba3-dcf5e474ce81' && pageData.id !== '602edc76-226b-5118-9cad-f7caadd40c2b' && pageData.blogListPicker !== null) && pageData.blogListPicker.length !== 0 && (
                <div className='block' style={{ backgroundColor: pageData.id === '22115bb8-499c-5e7e-b88d-682a112012d9' ? 'rgb(229, 62, 62)' : '' }}>
                    <Container>
                        <BlogInterest content={pageData.blogListPicker} title={pageData.blogTitle !== null ? pageData.blogTitle : 'More Info'} classNameVal={pageData.id === '22115bb8-499c-5e7e-b88d-682a112012d9' ? 'mb-0' : 'mb-30'} hasCustomClass={pageData.id === '22115bb8-499c-5e7e-b88d-682a112012d9' ? false : true} colorValue={pageData.id === '22115bb8-499c-5e7e-b88d-682a112012d9' ? 'rgb(229, 62, 62)' : ''} />
                    </Container>
                </div>
            )}
        </Layout>
    )
}

export const query = graphql`
    query ($id: String) {
        contentfulPage(id: {eq: $id}) {
            pageLanguage
            id
            slug
            isHeaderDark
            pageTitle
            seoImage
            headerPageTitle
            pageSubTitle
            seoPageTitle
            tags
            metaDescription {
                metaDescription
            }
            pageMediaList {
                gatsbyImageData(width: 2400, quality: 100)
            }
            coffeePackagingTourImage
            contactPageWhySavor
            pageGallery {
                galleryName
                galleryNameVisibility
                galleryLayoutOptions
                stackColumnNumber
                galleryFitOption
                hasWhiteBackground
                colorPicker
                hasMagnifier
                gallery {
                  gatsbyImageData(width: 2400, quality: 100)
                }
                videoGallery {
                    picture {
                        gatsbyImageData(width: 2400, quality: 100)
                    }
                    videoLink
                }
            }
            blogTitle
            blogListPicker {
                blogPostUrlSlug
            }
            hasContactForm
            homeHeroSlider{
                title
                buttonName
                titleLink
                isNoFollow
                content {
                    raw
                }
                backgroundImage {
                    gatsbyImageData(width: 2400, quality: 100)
                }
            }
            listOfCertifiedLogos {
                title
                logos {
                    gatsbyImageData(width: 2400, quality: 100)
                }
            }
            pageContentTwoColumn {
                title
                titleNotes
                titleVisibility
                backgroundColor
                image {
                    gatsbyImageData(width: 2400, quality: 100)
                }
                contentMedia
                contentColor
                content {
                    content
                }
                intro {
                    intro
                }
                contentLists {
                    title
                    titleColor
                    content {
                        content
                    }
                }
            }
            pageContentCard {
                title
                titleNotes
                cardLists {
                    __typename
                    ... on ContentfulPageContentCardLists {
                        title
                        content {
                            content
                        }
                        image {
                            gatsbyImageData(width: 2400, quality: 100)
                        }
                    }
                }
            }
            tooltip {
                title
                subtext
                content { content }
            }
            accessoriesSection {
                title
                backgroundMedia
                images {
                    gatsbyImageData(width: 2400, quality: 100)
                }
                content {
                    content
                }
            }
            pageHero {
                hasBanner
                multipleImages {
                    title
                    isCustomize
                    backgroundMedia
                    images {
                        gatsbyImageData(width: 2400, quality: 100)
                    }
                    videos {
                        picture {
                            gatsbyImageData(width: 2400, quality: 100)
                        }
                        videoLink
                    }
                    content {
                        content
                    }
                    buttonConfig {
                        buttonName
                        buttonLink
                        isNoFollow
                    }
                }
                textImage {
                    title
                    containerTopSpacing
                    backgroundMedia {
                        gatsbyImageData(width: 2400, quality: 100)
                    }
                    position
                    imageCustomizeSize
                    image 
                    content {
                        content
                    }
                    buttonConfig {
                        buttonName
                        buttonLink
                        isNoFollow
                    }
                }
                imageTextBlend {
                    title
                    backgroundMedia {
                        gatsbyImageData(width: 2400, quality: 100)
                    }
                    image
                    content {
                        content
                    }
                    overlayTitle
                    lists {
                        title
                        description {
                            description
                        }
                    }
                }
                miniSlider {
                    title
                    content {
                        content
                    }
                    backgroundImage {
                        gatsbyImageData(width: 2400, quality: 100)
                    }
                    buttonConfiguration {
                        buttonName
                        buttonLink
                        isNoFollow
                    }
                }
            }
            pageContentSection {
                sections {
                    __typename
                    ... on ContentfulMediaTextBlock {
                        mediaTextBlockName
                        isMediaTextBlockNameVisible
                        mediaTextBlockImages {
                        gatsbyImageData(width: 2400, quality: 100)
                        }
                        mediaTextBlockDescription {
                            mediaTextBlockDescription
                        }
                        mediaTextBlockYoutubeLink
                    }
                    ... on ContentfulPageContentCard {
                        title
                        titleNotes
                        cardListsColumnCount
                        cardLists {
                            __typename
                            ... on ContentfulPostsHub {
                                name
                                slug
                                postType
                                thumbnail {
                                    image { gatsbyImageData(width: 2400, quality: 100) }
                                    altTag
                                }
                                heroContent {
                                    title
                                    containerTopSpacing
                                    backgroundMedia { gatsbyImageData(width: 2400, quality: 100) }
                                    position
                                    imageCustomizeSize
                                    image
                                    content { content }
                                    buttonConfig {
                                      buttonName
                                      buttonLink
                                      isNoFollow
                                    }
                                }
                                dateOfEvent
                                moderator
                                darkerLogo {
                                    image { gatsbyImageData(width: 2400, quality: 100) }
                                    altTag
                                }
                                lighterLogo {
                                    image { gatsbyImageData(width: 2400, quality: 100) }
                                    altTag
                                }
                                eventSummary { eventSummary }
                            }
                        }
                    }
                  
                    # If there are other types of sections, you can include them as well
                }
                showOpportunitesResources
            }
            landingSections {
                title
                wholeBackground
                backgroundImage {
                    gatsbyImageData(width: 2400, quality: 100)
                }
                mainColumnCount
                mainMaxPostsOnFirstLoad
                showTheLatestPosts
                mainBlogs {
                    title
                    blogPostUrlSlug
                    languagePreference
                    excerpt {
                        raw
                    }
                    parentCategory{
                        categoryName
                        slugId
                    }
                    thumbnailImage {
                        gatsbyImageData(width: 2400, quality: 100)
                    }
                }
                mainVideos {
                    title
                    content {
                        content
                    }
                    media
                    link
                }
                sideTitle
                sideBlogPosition
                maxPostsOnFirstLoad
                sideBlogs {
                    publishDate
                    title
                    blogPostUrlSlug
                    languagePreference
                    excerpt {
                        raw
                    }
                    parentCategory{
                        categoryName
                        slugId
                    }
                    thumbnailImage {
                        gatsbyImageData(width: 2400, quality: 100)
                    }
                }
                sideVideos {
                    title
                    content {
                        content
                    }
                    media
                    link
                }
            }
            infoCard {
                title
                description {
                    description
                }
                image {
                    gatsbyImageData(width: 2400, quality: 100)
                }
                link
            }
            worldwideStateAndCountryCatalog {
                name
                link
                locationType
                subdirectory
            }
        }
        allContentfulCoffeePackagingTour(sort: { fields: sequence }) {
            edges {
              node {
                tourTitle {
                    tourTitle
                }
                description {
                    description
                }
                hasDotImage
                language
              }
            }
        }
        allContentfulPackagingParts(
            sort: { fields: sequence, order: ASC }
          ) {
            nodes {
              sequence
              title
              info {
                  info
              }
              thumbnailImage {
                  gatsbyImageData(width: 2400, quality: 100)
              }
            }
        }
        allContentfulPostsHub {
            nodes {
                seoTitle
                seoMetaDescription { seoMetaDescription }
                seoTags
                name
                slug
                postType
                thumbnail {
                    image { gatsbyImageData(width: 2400, quality: 100) }
                    altTag
                }
                heroContent {
                    title
                    containerTopSpacing
                    backgroundMedia { gatsbyImageData(width: 2400, quality: 100) }
                    position
                    imageCustomizeSize
                    image
                    content { content }
                    buttonConfig {
                    buttonName
                    buttonLink
                    isNoFollow
                    }
                }
                dateOfEvent
                moderator
                darkerLogo {
                    image { gatsbyImageData(width: 2400, quality: 100) }
                    altTag
                }
                lighterLogo {
                    image { gatsbyImageData(width: 2400, quality: 100) }
                    altTag
                }
                eventSummary { eventSummary }
            }
        }
    }
`

export const Head = ({data}) => {
    let priority = '0.5'; 
    if (data.contentfulPage.pageTitle === 'Home' || data.contentfulPage.pageTitle === 'About' || data.contentfulPage.pageTitle === 'Contact') {
        priority = '1.0';
    }

    // let noFollow= (data.contentfulPage.id === '49d10d35-2cdd-5bae-aaa8-2b1624b3749c' || data.contentfulPage.id === 'd74ab9f2-ba81-5d91-889c-3db2f2de05a9' || data.contentfulPage.pageLanguage === 'Spanish' ) ? false : true
    let noFollow= (data.contentfulPage.id === '49d10d35-2cdd-5bae-aaa8-2b1624b3749c' || data.contentfulPage.id === 'd74ab9f2-ba81-5d91-889c-3db2f2de05a9' ) ? false : true
    let slugUrl = `https://www.savorbrands.com${data.contentfulPage.slug}`

    return (
        <MetaHead 
            title={data.contentfulPage.pageTitle} 
            description={data.contentfulPage.metaDescription.metaDescription} 
            titleSEO={data.contentfulPage.seoPageTitle} 
            tags={data.contentfulPage.tags} 
            seoImage={data.contentfulPage.seoImage} 
            priority={priority} 
            isFollow={noFollow}
            slugUrl={slugUrl}
        />
    )
}

export default Page